import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import {
   DropdownMenu,
   DropdownMenuContent,
   DropdownMenuItem,
   DropdownMenuTrigger,
} from '@ifixit/ui/components/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@ifixit/ui/components/tooltip';
import { cn } from '@ifixit/ui/lib/utils';
import { noteTypeLabels, noteTypes } from '../../extensions/note';
import { tiptapButtonClassName } from '../TiptapButton';
import { refocusOnClose } from './refocus_on_close';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export function NoteDropdown() {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('note'),
      isDisabled: !editor.can().toggleNote('note'),
      activeType: noteTypes.find(type => editor.isActive('note', { type })),
   }));

   if (!state) {
      return null;
   }

   const { isActive, isDisabled, activeType } = state;

   const handleOpenChange = refocusOnClose(editor);

   return (
      <Tooltip>
         <DropdownMenu onOpenChange={handleOpenChange}>
            <TooltipTrigger asChild>
               <DropdownMenuTrigger asChild>
                  <button
                     type="button"
                     disabled={isDisabled}
                     data-active={isActive ? 'true' : undefined}
                     aria-label={_js('Insert a note')}
                     className={cn(tiptapButtonClassName, 'p-1')}
                  >
                     <span className="inline-flex items-center gap-[7px]">
                        <FaIcon name="circle-info" />
                        <FaIcon name="chevron-down" />
                     </span>
                  </button>
               </DropdownMenuTrigger>
            </TooltipTrigger>
            <DropdownMenuContent align="start">
               {noteTypes.map(type => {
                  const isCurrentType = type === activeType;
                  const onSelectHandler =
                     !isCurrentType && isActive
                        ? () => editor.chain().focus().setNoteType(type).run()
                        : () => editor.chain().focus().toggleNote(type).run();
                  return (
                     <DropdownMenuItem key={type} onSelect={onSelectHandler}>
                        {noteTypeLabels[type]}
                     </DropdownMenuItem>
                  );
               })}
            </DropdownMenuContent>
         </DropdownMenu>
         <TooltipContent side="top" align="start">
            {_js('Insert a note')}
         </TooltipContent>
      </Tooltip>
   );
}
